import { mm } from './units';

export const PROFILE = {
  frameWidth: mm(70),
  frameDepth: mm(80),
  sashWidth: mm(50),
  sashDepth: mm(60),
  mullionWidth: mm(60),
  mullionDepth: mm(80),
  glassThickness: mm(24),
  tripleGlassThick: mm(36),
  vacuumGlassThick: mm(10),
  roedenBarWidth: mm(26),
  roedenBarDepth: mm(8),
  handleWidth: mm(12),
  handleHeight: mm(100),
  handleDepth: mm(30),
  sillHeight: mm(35),
  sillDepth: mm(100),
};
